import { DevicePreset, DeviceCategory } from '../../core/types/live-preview.types';

export const DEVICE_PRESETS: DevicePreset[] = [
  // Mobile - iPhone
  {
    id: 'iphone-se',
    name: 'iPhone SE',
    category: 'mobile',
    width: 375,
    height: 667,
    pixelRatio: 2,
    isPortrait: true,
    icon: 'smartphone',
  },
  {
    id: 'iphone-14',
    name: 'iPhone 14',
    category: 'mobile',
    width: 390,
    height: 844,
    pixelRatio: 3,
    isPortrait: true,
    icon: 'smartphone',
  },
  {
    id: 'iphone-14-pro-max',
    name: 'iPhone 14 Pro Max',
    category: 'mobile',
    width: 430,
    height: 932,
    pixelRatio: 3,
    isPortrait: true,
    icon: 'smartphone',
  },
  {
    id: 'iphone-15-pro',
    name: 'iPhone 15 Pro',
    category: 'mobile',
    width: 393,
    height: 852,
    pixelRatio: 3,
    isPortrait: true,
    icon: 'smartphone',
  },

  // Mobile - Android
  {
    id: 'pixel-7',
    name: 'Pixel 7',
    category: 'mobile',
    width: 412,
    height: 915,
    pixelRatio: 2.625,
    isPortrait: true,
    icon: 'smartphone',
  },
  {
    id: 'samsung-s23',
    name: 'Samsung S23',
    category: 'mobile',
    width: 360,
    height: 780,
    pixelRatio: 3,
    isPortrait: true,
    icon: 'smartphone',
  },
  {
    id: 'samsung-s23-ultra',
    name: 'Samsung S23 Ultra',
    category: 'mobile',
    width: 384,
    height: 824,
    pixelRatio: 3,
    isPortrait: true,
    icon: 'smartphone',
  },

  // Tablet
  {
    id: 'ipad',
    name: 'iPad',
    category: 'tablet',
    width: 810,
    height: 1080,
    pixelRatio: 2,
    isPortrait: true,
    icon: 'tablet',
  },
  {
    id: 'ipad-pro-11',
    name: 'iPad Pro 11"',
    category: 'tablet',
    width: 834,
    height: 1194,
    pixelRatio: 2,
    isPortrait: true,
    icon: 'tablet',
  },
  {
    id: 'ipad-pro-12',
    name: 'iPad Pro 12.9"',
    category: 'tablet',
    width: 1024,
    height: 1366,
    pixelRatio: 2,
    isPortrait: true,
    icon: 'tablet',
  },
  {
    id: 'android-tablet',
    name: 'Android Tablet',
    category: 'tablet',
    width: 800,
    height: 1280,
    pixelRatio: 2,
    isPortrait: true,
    icon: 'tablet',
  },

  // Desktop
  {
    id: 'hd',
    name: 'HD (720p)',
    category: 'desktop',
    width: 1280,
    height: 720,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'monitor',
  },
  {
    id: 'full-hd',
    name: 'Full HD (1080p)',
    category: 'desktop',
    width: 1920,
    height: 1080,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'monitor',
  },
  {
    id: '2k',
    name: '2K (1440p)',
    category: 'desktop',
    width: 2560,
    height: 1440,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'monitor',
  },
  {
    id: '4k',
    name: '4K (2160p)',
    category: 'desktop',
    width: 3840,
    height: 2160,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'monitor',
  },
  {
    id: 'ultrawide',
    name: 'Ultrawide (21:9)',
    category: 'desktop',
    width: 2560,
    height: 1080,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'monitor',
  },
  {
    id: 'super-ultrawide',
    name: 'Super Ultrawide (32:9)',
    category: 'desktop',
    width: 3840,
    height: 1080,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'monitor',
  },

  // Consoles
  {
    id: 'switch',
    name: 'Nintendo Switch',
    category: 'console',
    width: 1280,
    height: 720,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'gamepad',
  },
  {
    id: 'switch-handheld',
    name: 'Switch Handheld',
    category: 'console',
    width: 1280,
    height: 720,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'gamepad',
  },
  {
    id: 'steam-deck',
    name: 'Steam Deck',
    category: 'console',
    width: 1280,
    height: 800,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'gamepad',
  },
  {
    id: 'ps5-xbox',
    name: 'PS5 / Xbox Series',
    category: 'console',
    width: 1920,
    height: 1080,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'gamepad',
  },
  {
    id: 'ps5-xbox-4k',
    name: 'PS5 / Xbox 4K',
    category: 'console',
    width: 3840,
    height: 2160,
    pixelRatio: 1,
    isPortrait: false,
    icon: 'gamepad',
  },
];

export const DEVICE_CATEGORIES: { id: DeviceCategory; label: string; icon: string }[] = [
  { id: 'mobile', label: 'Mobile', icon: 'smartphone' },
  { id: 'tablet', label: 'Tablet', icon: 'tablet' },
  { id: 'desktop', label: 'Desktop', icon: 'monitor' },
  { id: 'console', label: 'Console', icon: 'gamepad' },
  { id: 'custom', label: 'Custom', icon: 'ruler' },
];

export const getPresetsByCategory = (category: DeviceCategory): DevicePreset[] => {
  return DEVICE_PRESETS.filter((preset) => preset.category === category);
};

export const getPresetById = (id: string): DevicePreset | undefined => {
  return DEVICE_PRESETS.find((preset) => preset.id === id);
};

export const SCALE_PRESETS = [
  { value: 0.25, label: '25%' },
  { value: 0.5, label: '50%' },
  { value: 0.75, label: '75%' },
  { value: 1, label: '100%' },
  { value: 1.25, label: '125%' },
  { value: 1.5, label: '150%' },
  { value: 2, label: '200%' },
];

export const FPS_PRESETS = [
  { value: 30, label: '30 FPS' },
  { value: 60, label: '60 FPS' },
  { value: 120, label: '120 FPS' },
  { value: 144, label: '144 FPS' },
  { value: 0, label: 'Unlimited' },
];
